import { Col, Row } from 'react-bootstrap';
import DoubleComparisonColumnsChart from '../../../../components/ApexCharts/DoubleComparisonColumnsChart';
import ColumnsCustomLegend from '../../../../components/ApexCharts/CustomLegends/ColumnsCustomLegend';
import Blockquote from '../../../../components/Blockquote';
import CalloutCard from '../../../../components/CalloutCard';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Button from '../../../../components/Button';
import { formatPrice } from '../../../../utils/utils';
import { Link } from 'react-router-dom';

const retirementOptionsData = {
  chart: {
    id: 'comparison-columns',
    height: 350,
    stacked: true,
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  colors: ['#07B4A0', '#EEA968', '#0795B4'],
  series: [
    {
      name: '401 (k) Plan',
      data: [
        { x: 2, y: 4500 }, //2 is 'We Year-to-Date'
        { x: 4, y: 4334 }, //4 is 'You Year-to-Date'
        { x: 8, y: 4500 }, //8 is 'We Annual Projection'
        { x: 10, y: 17334 }, //10 is 'You Annual Projection'
      ],
    },
    {
      name: 'Pension Plan',
      data: [
        { x: 2, y: 4345 },
        { x: 4, y: 0 },
        { x: 8, y: 4345 },
        { x: 10, y: 0 },
      ],
    },
    {
      name: 'Estimated Social Security and Medicare',
      data: [
        { x: 2, y: 5946 },
        { x: 4, y: 6469 },
        { x: 8, y: 14866 },
        { x: 10, y: 16173 },
      ],
    },
  ],
  dataLabels: {
    enabled: false,
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    labels: {
      show: false,
    },
  },
  yaxis: {
    categories: [0, 2500, 7500, 10000, 12500, 15000, 17500],
    title: {
      text: '',
    },
    labels: {
      formatter: function (a: any) {
        return formatPrice(a, 'en-US', {
          currency: 'USD',
          style: 'currency',
          minimumFractionDigits: 0,
        });
      },
    },
  },
};

const retirementToolButton = [
  <Link to={'/retirement-planning'} className={'text-decoration-none'}>
    <Button
      variant="secondary-outline"
      rightIcon={light('person-cane')}
      className="callout-button"
      size="sm"
    >
      Retirement Planning
    </Button>
  </Link>,
];
const RetirementTab = () => {
  return (
    <div className="pt-11">
      <Row>
        <h5>Retirement</h5>
      </Row>
      <Row>
        <span className="text-light-grey text-fs-6 fw-light lh-xs">
          The graphs below breakdown the current Year-to-Date (YTD)
          contributions made by both you and your company, and the projected
          annual contributions for both you and your company.
        </span>
      </Row>
      <Row className="pt-11 lh-xs px-4">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">
                Let's help you understand this information
              </Col>
            </Row>
            <Row>
              <Col>
                Cash Compensation is shown by calendar year. Your current year
                amount represents what you have received year-to-date plus a
                projection based on your current pay rate.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-12 px-lg-0 ">
        <Col className="col-12 ">
          <DoubleComparisonColumnsChart options={retirementOptionsData} />
        </Col>
      </Row>
      <div className="overflow-auto ">
        <div style={{ minWidth: '520px' }}>
          <div className="pt-12  px-7">
            <Col className="pt-3 lh-xs col-12 px-lg-7">
              <Row className="text-fs-6 fw-light pt-3 lh-xs border-bottom">
                <Col className=" text-ligther-grey"></Col>
                <Col className="col-3 text-end">YTD Contributions</Col>
                <Col className="col-3 text-end">Annual Projection</Col>
              </Row>
              <Row className="text-fs-6 fw-light pt-3 pb-3 lh-xs border-bottom">
                <Col className="col-6 text-ligther-grey fw-normal">
                  Compensation
                </Col>
                <Col className="text-end fw-normal">We</Col>
                <Col className="text-end fw-normal">You</Col>
                <Col className="text-end fw-normal">We</Col>
                <Col className="text-end fw-normal">You</Col>
              </Row>

              <ColumnsCustomLegend
                series={[
                  { name: '401 (k) Plan', data: [4500, 4334, 4500, 17334] },
                  { name: 'Pension Plan', data: [4345, 0, 4345, 0] },
                  {
                    name: 'Estimated Social Security and Medicare',
                    data: [5946, 6469, 14866, 16173],
                  },
                ]}
                colors={retirementOptionsData.colors}
                total={['$14,791', '$10,803', '$23,711', '$33,507']}
              />
            </Col>
          </div>
        </div>
      </div>

      <Row className="pt-12 px-7 lh-xs text-light-grey text-fs-6 fw-light">
        Employer contributions are posted annually for the prior calendar year's
        contributions. Social security and medicare projected amounts are based
        on current YTD contributions; your actual amounts may vary.
      </Row>
      <Row className="pt-11 mt-11 lh-xs">
        <h5>Suggestions</h5>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">Retirement Savings</Col>
            </Row>
            <Row>
              <Col>
                It looks like you are not contributing to the 401(k) plan. By
                not contributing to the plan, you are missing out on free money
                from your company to help save for retirement. Go to the My
                401(k) tab to update your contribution elections or the
                Retirement Planning tab to model your retirement income.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <CalloutCard
          cardIcon={light('screwdriver-wrench')}
          buttons={retirementToolButton}
        >
          <Row className="content-row">
            <Col>
              <span className="bolder-text me-1">Retirement Savings:</span>
              Saving for retirement is always a good idea but having a strategy
              that realizes your needs in retirement is even better. Use our
              retirement tools to help create your strategy.
            </Col>
          </Row>
        </CalloutCard>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">Pension</Col>
            </Row>
            <Row>
              <Col>
                Along with Social Security, your pension benefit provides an
                annuity payment stream that can act as a base income that
                protects your Retirement Savings accounts (the larger the
                annuities you have, the less you have to withdraw from your
                Savings accounts). Make sure to include this balance in your
                retirement modeling.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
    </div>
  );
};
export default RetirementTab;
